import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import BtnListTypeSetting from 'components/property-settings/btn-list-type-setting/btn-list-type-setting';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { Box, Typography } from '@mui/material';

type ClaspTypesProps = {
    handleSettings: (propertyName: string, settingValue: string) => void;
    claspType: string;
    options?: string[];
    isRequired?: boolean;
};

const ClaspTypes: FC<ClaspTypesProps> = ({ handleSettings, claspType, options, isRequired }: ClaspTypesProps) => {
    const { t: translate } = useTranslation(['construction-props']);

    return (
        <PropertyBox>
            <Box display="flex">
                <PropertyLabel variant="h5">{translate('CLASP_TYPES')}</PropertyLabel>
                {isRequired && (
                    <Typography
                        component="span"
                        color="error"
                        fontSize={18}
                        sx={{ marginLeft: '2px', marginTop: '-5px' }}
                    >
                        *
                    </Typography>
                )}
            </Box>
            <BtnListTypeSetting
                setting={options ? options : CONSTANTS.CLASP_TYPES}
                propertyName="claspType"
                settingValue={claspType}
                handlePropertySelection={handleSettings}
            />
        </PropertyBox>
    );
};

export default ClaspTypes;
